import React, {useCallback, createRef, useEffect, useState, useRef} from 'react';
import BriefForm from './BriefForm';
import BriefSteps from './BriefSteps';
import BriefRooms from './BriefRooms';
import BriefYouReceivePage from './BriefYouReceivePage';
import BriefAddress from './BriefAddress';
import { useDispatch, useSelector } from '../store';
import {gettingStartedSelector} from '../store/selectors';
import {prepareQuestionnaireData, prepareQuestionnairePlanData} from '../utils/data';
import cn from 'classnames';
// import BriefPlan from "./BriefPlan";
import {
  BrowserRouter as Router,
  Link,
  useLocation,
  useHistory } from 'react-router-dom';
// import BriefWelcome from "./BriefWelcome";
import BriefDelivery from "./BriefDelivery/BriefDelivery";
import Svg from "../../../common/components/Svg";
import ReviewsIoWidget from "./ReviewsIoWidget";
// import {useNavigate} from 'react-router-dom';

// const PAGE_WELCOME = 'welcome';
const PAGE_ROOMS = 'rooms';
const YOU_RECEIVE = 'you_receive';
const PAGE_PLAN = 'plan';
const PAGE_ADDRESS = 'address';

const welcomeFormValidation = values => {
  return true;
};

const roomsFormValidation = values => {
  const { rooms } = values;
  return rooms && rooms.length > 0;
};

const EXPRESS_NORMAL = ['express', 'normal'];
const roomTypeAndPlanValid = (values, roomType, index) => {
  const roomPlan = values.packages[`${roomType}_${index}`];
  return roomPlan && EXPRESS_NORMAL.includes(roomPlan.term);
};

const planValid = (values, roomType, quantity) => {
  let valid = true;
  Array.from(Array(quantity).keys()).forEach((n) => {
    valid = valid && roomTypeAndPlanValid(values, roomType, n + 1)
  });
  return valid;
};

const planFormValidation = values => {
  let valid = true;
  (values.rooms || []).forEach((r) => {
    valid = valid && planValid(values, r.type, r.quantity);
  });
  return valid;
};

const addressFormValidation = values => {
  let valid = true;
  const { address, postcode, town } = values.address;
  valid = valid && address && address.length > 1;
  valid = valid && postcode && postcode.length > 1;
  valid = valid && town && town.length > 1;
  return !!valid;
};

const validateForm = (pageParams, pageId, values) => {
  const validation = pageParams[pageId];
  return validation && validation.formValidation && validation.formValidation(values);
};


export const PAGE_PARAMS = {
  // [PAGE_WELCOME]: {
  //   nextPageUrl: '/getting_started/step1?question=rooms',
  //   nextPageReact: true,
  //   noSteps: true,
  //   noNext: true,
  //   modificator: '-welcome',
  //   customNextButton: true,
  //   formValidation: welcomeFormValidation,
  // },
  [PAGE_ROOMS]: {
    stepNum: 1,
    stepName: 'Room choice',
    prevPageUrl: '/',
    // nextPageUrl: '/getting_started/step1?question=you_receive',
    // nextPageReact: true,
    nextPageUrl: '/getting_started/next',
    nextPageReact: false,
    formValidation: roomsFormValidation,
  },
  [YOU_RECEIVE]: {
    stepNum: 1,
    stepName: "What's included",
    prevPageUrl: '/getting_started/step1?question=rooms',
    nextPageUrl: '/getting_started/next',
    nextPageReact: false,
    formValidation: roomsFormValidation,
  },
  [PAGE_PLAN]: {
    stepNum: 2,
    stepName: 'Turnaround time',
    // prevPageUrl: '/getting_started/step1?question=you_receive',
    prevPageUrl: '/getting_started/step1',
    nextPageUrl: '/getting_started/next',
    nextPageReact: false,
    formValidation: planFormValidation,
  },
  [PAGE_ADDRESS]: {
    stepNum: 3,
    stepName: 'Address for designs',
    prevPageUrl: '/getting_started/step2',
    nextPageUrl: '/getting_started/next',
    nextPageReact: false,
    formValidation: addressFormValidation,
  },
};

export const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

// const Brief = ({ form: formProps, rooms_options: roomsOptions, initialQuestion, ...initialProps }) => {
const Brief = ({ form: formProps, initialQuestion, ...initialProps }) => {
  const dispatch = useDispatch();
  const {
    values: {
      rooms,
      address,
      packages,
    },
    values,
    prices,
    packagesOptions,
    form: formState,
    proPlatform,
    roomsDelivery,
    roomsOptions,
    roomsParams,
    newCustomer,
    // roomsPackages,
    // plansOptions,
  } = useSelector(gettingStartedSelector);

  const query = useQuery();

  const queryQuestion = query.get('question') || initialQuestion;
  // debugger;
  // if (queryQuestion === 'you_receive' && values.rooms.length === 0) { queryQuestion = null };
  const pageId = PAGE_PARAMS[queryQuestion] ? queryQuestion : PAGE_ROOMS;
  const pageParams = PAGE_PARAMS[pageId];

  const form = createRef();

  useEffect(() => {
    dispatch({ type: 'gettingStarted/update', payload: prepareQuestionnaireData(initialProps) });
  }, []);

  const handleRoomsChange = useCallback(
    room => {
      let newRooms = rooms.filter(r => r.type !== room.type);
      if (room.quantity > 0) {
        newRooms = [...newRooms, room];
      }
      dispatch({ type: 'gettingStarted/update', payload: { rooms: newRooms } });
    },
    [dispatch, rooms],
  );

  const handleDeliveryChange = useCallback(
    (room, newDelivery) => {
      const newPackages = {
        ...values.packages,
        [room.value]: {
          ...(values.packages[room.value] || {}),
          term: newDelivery.id,
          type: room.name,
          index: room.index,
        },
      };
      dispatch({ type: 'gettingStarted/update', payload: { packages: newPackages } });
    },
    [values.packages],
  );

  const formValid = validateForm(PAGE_PARAMS, pageId, values);
  const [loading, setLoading] = useState(false);

  const handleAddressChange = useCallback(address => {
    dispatch({ type: 'gettingStarted/update', payload: { address } });
  }, []);

  const history = useHistory();

  const briefRef = useRef(null);

  const handleNext = useCallback(
    event => {
      event.preventDefault();
      if (pageParams.nextPageReact) {
        window.scrollTo(0, 0);
        //  do not save, just navigate
        history.push(pageParams.nextPageUrl);
        if (briefRef && briefRef.current) {
          briefRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        if (form && form.current) {
          const formCurrent = form.current;
          setLoading(true);
          // Safari fix
          console.log('Submit is native:', typeof formCurrent.submit === 'function');
          console.log('Form method:', formCurrent.method); // should say "post"
          console.log('Form action:', formCurrent.action); // should be your expected URL
          requestAnimationFrame(() => {
            formCurrent.setAttribute('method', 'POST');
            // form.current.method = 'POST';
            formCurrent.submit();
          });
        }
      }
    },
    [form, pageParams, history, briefRef], // Safari fix
  );

  // add class to brief element from array

  return (
    <div className={cn(`brief ${pageParams.modificator ? pageParams.modificator : ''}`, {'-new-customer': newCustomer})} ref={briefRef}>
      <nav className="brief_header">
        <div className="container brief_container">
          <div className="brief_header-grid">
            {pageParams.noSteps ? null : (
              <div className="brief_header-grid-item -step">

                {pageParams.stepNum && (
                  <div className="brief_step-info">
                    <div className={`brief_step-info-circle -step-${pageParams.stepNum}-5`}>
                      <div className="brief_step-info-circle-inner">
                        {pageParams.stepNum}
                      </div>
                    </div>
                    <div className="brief_step-info-text">
                      <div className="brief_step-info-hint">
                        Step {pageParams.stepNum} of 5
                      </div>
                      <div className="brief_step-info-title">
                        {pageParams.stepName ? pageParams.stepName : ''}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            <div className="brief_header-grid-item -logo">
              <a href="/" className="brief_header-link-logo">
                <Svg icon="icon-logo-yellow" className="brief_header-logo" />
              </a>
            </div>
            {pageParams.prevPageUrl ? (
              <div className="brief_header-grid-item -back">
                <a className="brief_header-back_btn" href={pageParams.prevPageUrl}>
                  &lt; Back
                </a>
              </div>
            ) : null}
          </div>
        </div>
      </nav>
      {/*<div className='brief-banner-wrapper'>*/}
      {/*  {newCustomer && (*/}
      {/*    <div className='brief-banner -new-customer'>*/}
      {/*      Use <b><i>HELLO-10</i></b>&nbsp;for 10% of your first room*/}
      {/*    </div>*/}
      {/*  )}*/}
      {/*</div>*/}

      <BriefForm
        ref={form}
        {...formProps}
        values={{ rooms, address, packages }}
      >
        <div className={cn("container brief_container")}>
          <BriefSteps
            invalid={[
              formState.roomsInvalid,
              proPlatform ? formState.addressInvalid : false,
            ]}
            submitAction={proPlatform ? 'Submit' : 'Next question'}
            onNext={handleNext}
            noNextButton={pageParams.customNextButton}
          >
            {/*{pageId === PAGE_WELCOME ? (*/}
            {/*  <BriefWelcome onNext={handleNext}/>*/}
            {/*) : null}*/}

            {/*{pageId === YOU_RECEIVE ? (*/}
            {/*  <BriefYouReceivePage*/}
            {/*    value={rooms}*/}
            {/*    proPlatform={proPlatform}*/}
            {/*    options={roomsOptions}*/}
            {/*    onChange={handleRoomsChange}*/}
            {/*  />*/}
            {/*) : null}*/}

            {pageId === PAGE_ROOMS || pageId === YOU_RECEIVE ? (
              <BriefRooms
                value={rooms}
                proPlatform={proPlatform}
                options={roomsOptions}
                onChange={handleRoomsChange}
              />
            ) : null}

            {pageId === PAGE_PLAN ? (
              <BriefDelivery
                value={packages}
                rooms={roomsDelivery}
                prices={prices}
                delivery={packagesOptions}
                roomsOptions={roomsOptions}
                onChange={handleDeliveryChange}
              />
            ) : null}

            {pageId === PAGE_ADDRESS ? (
              <BriefAddress
                value={address}
                proPlatform={proPlatform}
                onChange={handleAddressChange}
              />
            ) : null}
          </BriefSteps>
        </div>
      </BriefForm>

      {pageParams.noNext ? null : (
        <footer className={cn("brief_footer")}>
          <div className={cn("container brief_container")}>
            <button
              type="button"
              className={cn("btn -gold -brief", { "-disabled": !formValid || loading })}
              onClick={formValid && !loading ? handleNext : undefined}
            >
              Continue
            </button>
          </div>
        </footer>
      )}

    </div>
  );
};

export default Brief;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/Brief.js